import { Box } from "@mui/material";

import { type CompatibleColor, getCompatibleColor } from "../../internal/getCompatibleColor";
import { CbhIcon, type IconType } from "../CbhIcon";
import { Text } from "../Text";

/**
 * If we need to add more sizes, we can add them here. At the time of writing the component, there
 * are no designs for other sizes.
 */
export interface IconWithCountProps {
  iconType: IconType;
  count: number;
  color?: CompatibleColor;
}

export function IconWithCount(props: IconWithCountProps) {
  const { iconType, count, color } = props;

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <CbhIcon type={iconType} size="medium" sx={{ color }} />

      <Text
        variant="body2"
        sx={(theme) => ({
          color: getCompatibleColor({
            color,
            defaultColor: theme.palette.text.secondary,
            theme,
          }),
        })}
      >
        {count}
      </Text>
    </Box>
  );
}
